import { createFileRoute } from "@tanstack/react-router";
import {
  EventDetailView,
  buildEventMeta,
  loadEventMeta,
} from "@/components/event-detail-view";

export const Route = createFileRoute("/eventos/$eventId")({
  loader: async ({ params }) => ({ meta: await loadEventMeta(params.eventId) }),
  head: ({ params, loaderData }) =>
    buildEventMeta(loaderData?.meta ?? null, `https://brulo.fit/evento/${params.eventId}`),
  component: () => {
    const { eventId } = Route.useParams();
    return <EventDetailView eventId={eventId} />;
  },
});
